import { render } from "./CZHistoricConsumptionCo2EB.vue?vue&type=template&id=612c31d0&scoped=true&ts=true"
import script from "./CZHistoricConsumptionCo2EB.vue?vue&type=script&lang=ts"
export * from "./CZHistoricConsumptionCo2EB.vue?vue&type=script&lang=ts"

import "./CZHistoricConsumptionCo2EB.vue?vue&type=style&index=0&id=612c31d0&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612c31d0"]])

export default __exports__